/** TR04 copy (one group per control; a ticket edits only its own file). */
export const tr04PtBr = {
  title: 'Caixa físico, contas de pagamento e cartões',
  description:
    'Composição de caixa físico, contas de pagamento e cartões contra o auxiliar e o razão.',
  prerequisite:
    'Requer contagem ou atestado de caixa datado, razão de cartões e auxiliar das contas de pagamento.',
  diagnosticLabel: 'Fontes ainda sem cobertura',
  reasons: {
    CARD_NOT_COVERED: 'Cartões sem auxiliar para comparar (nunca considerados conciliados)',
    PAYMENT_ACCOUNT_AUXILIARY_MISSING: 'Contas de pagamento sem auxiliar de composição',
  },
  observations: {},
};

export const tr04En: typeof tr04PtBr = {
  title: 'Physical cash, payment accounts and cards',
  description:
    'Composition of physical cash, payment accounts and cards against the auxiliary and the ledger.',
  prerequisite:
    'Needs a dated cash count or attestation, a card ledger and a payment-account auxiliary.',
  diagnosticLabel: 'Sources not covered yet',
  reasons: {
    CARD_NOT_COVERED: 'Cards with no auxiliary to compare (never treated as reconciled)',
    PAYMENT_ACCOUNT_AUXILIARY_MISSING: 'Payment accounts without a composition auxiliary',
  },
  observations: {},
};
